export default __webpack_public_path__ + "static/media/DAIF_Services_Screen1_in.a8b70fd2.mp4";